export default __webpack_public_path__ + "static/media/reload.c639bc80.svg";